<template>
    <div class="cz3__option-colors" v-auto-animate>
        <button
            v-for="c of colors"
            :key="c.code"
            class="cz3__option-color"
            :class="{
                'cz3__option-color--selected': selectedColor === c,
                'cz3__option-color--border': c.custom && c.custom.hex && c.custom.hex.toLowerCase().endsWith('ffffff'),
            }"
            :style="getStyle(c)"
            :aria-pressed="selectedColor === c"
            :aria-label="c.name"
            :title="c.name"
            @click.prevent="select(c)"
        >
        </button>

        <button v-if="!expanded && hasMore" class="cz3__option-colors__view-more" @click.prevent="expand">
            <span>{{$t('V3_VIEW_MORE')}}</span>
        </button>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz3__option-colors__view-more {
            position: relative;

            width: 73px;
            height: 40px;

            border-radius: 8px;

            border: none;
            background: transparent;

            &:focus {
                outline: 2px solid #000;
                outline-offset: 2px;
            }

            display: flex;
            justify-content: center;
            align-items: center;

            span {
                font-family: $font-main;
                font-weight: 400;
                font-size: 12px;

                text-decoration: underline;
                text-underline-offset: 1px;
            }
        }
    }
</style>

<script>
    export default {
        props: {
            availableColors: Array,
            selectedColor: Object,
            maxItems: Number,
        },

        data() {
            return {
                expanded: this.maxItems == null,
            };
        },

        computed: {
            colors() {
                if (this.expanded) {
                    return this.availableColors;
                }

                return this.availableColors.slice(0, this.maxItems);
            },

            hasMore() {
                return this.availableColors.length > this.maxItems;
            },
        },

        methods: {
            select(color) {
                this.$emit('select', color);
            },

            expand() {
                this.expanded = true;
            },

            getStyle(color) {
                const css = {};

                if (color && color.custom && color.custom.hex) {
                    css.backgroundColor = color.custom.hex.startsWith('#') ? color.custom.hex : `#${color.custom.hex}`;
                }

                return css;
            },
        },
    };
</script>
